import request from '@/utils/request'

// 登录
// export function login(data) {
//   return request({
//     url: '/auth/v1/login',
//     method: 'post',
//     data
//   })
// }

// 验证码登录
export function login(data) {
  return request({
    url: 'auth/v1/login/captcha',
    method: 'post',
    data
  })
}


// 修改密码
export function updatepwd(data) {
  return request({
    url: '/user/updatePwd',
    method: 'put',
    data
  })
}

// 登录
export function getSms(query) {
  return request({
    url: '/auth/v1/getSms',
    method: 'get',
    params: query
  })
}
